<template>
  <div class="row">
    <div class="col-12">
      <card>
        <div class="card-body">
          <div class="row" v-if="isAdmin">
            <div class="col-12">
              <div class="float-right mb-4">
                <button class="btn btn-secondary btn-sm" @click="export2Excel">
                  <i class="fas fa-download fa-fw"></i> Download XLS
                </button>
              </div>
            </div>
          </div>
          <v-server-table ref="vuetable" url="/dtable/requests" :columns="columns" :options="options">
            <template slot="beforeFilter">
              <h2>
                <i class="fas fa-file-invoice text-primary"></i> {{$t('request.title')}}
              </h2>
            </template>
            <template
                slot="status"
                slot-scope="props"
            >{{ $t('request.option.' + props.row.status.toLowerCase().replace(/\s/g, '')) }}</template>
            <template slot="afterLimit">
              <router-link class="btn btn-primary ml-2" :to="{ name: 'request_parts'}">
                <i class="fas fa-plus fa-fw"></i> {{$t('request.button.addnew')}}
              </router-link>
            </template>
            <template slot="early_kit" slot-scope="props">
              <span v-if="props.row.early_kit" class="badge badge-success text-white">{{$t('request.earlykit')}}</span>
            </template>
            <template slot="id" slot-scope="props" class="btn-group" role="group">
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'requests_edit', params: { id: props.row.id } }"
              >
                <i class="fas fa-edit fa-fw"></i>
              </router-link>
              <router-link
                class="btn btn-xs btn-primary mr-1"
                :to="{ name: 'requests_delete', params: { id: props.row.id } }"
                 v-if="isAdmin"
              >
                <i class="fas fa-trash-alt fa-fw"></i>
              </router-link>
            </template>
          </v-server-table>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    }
  },
  data() {
    return {
      columns: [
        "request_code",
        "name",
        "status",
        "repair_id",
        "early_kit",
        "invoice_number",
        "created_at",
        "id"
      ],
      options: {
        orderBy: {
          ascending: false,
          column: "created_at"
        },
        dateColumns: ["created_at"],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          request_code: () => this.$t('request.code'),
          repair_id: () => this.$t('request.repairid'),
          name: () => this.$t('request.asf'),
          status: () => this.$t('request.status'),
          early_kit: "",
          invoice_number: () => this.$t('request.invoicenumber'),
          created_at: () => this.$t('request.createdat'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"]
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {
        
        const tHeader = this.columns.slice(0, -1);//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = this.columns.slice(0, -1);//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);
        
        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
};
</script>
<style>
</style>
